import styles from "./Tasks.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import CopyRight from "../../components/CopyRight/CopyRight";

const taskData = [
  {
    _id: "task1",
    studentName: "John Jacob",
    status: "Toured",
    staff: "02",
    dueDate: "2025-05-01",
  },
  {
    _id: "task2",
    studentName: "John Jacob",
    status: "Toured",
    staff: "02",
    dueDate: "2025-05-01",
  },
  {
    _id: "task3",
    studentName: "John Jacob",
    status: "Toured",
    staff: "02",
    dueDate: "2025-05-01",
  },
  {
    _id: "task4",
    studentName: "John Jacob",
    status: "Toured",
    staff: "02",
    dueDate: "2025-05-01",
  },
];

function Tasks() {
  const dispatch = useDispatch();
    const [selectedDate, setSelectedDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterDate, setFilterDate] = useState("");

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName} />,
        status: item.status,
        staff: item.staff,
        dueDate: new Date(item.dueDate).toLocaleDateString("en-GB"),
      };
    });
  };

  const displayData = getColumnData(taskData);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === taskData.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? taskData.map((item) => item._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Status", accessor: "status" },
    { title: "Assigned Staff", accessor: "staff" },
    { title: "Due Date", accessor: "dueDate" },
  ];

  return (
    <div className={styles.main}>
      <div className={styles.background}>
        
          {/* Top Status Boxes */}
          <div className={styles.rowWrapper}>
            <div className={styles.cardsWrapper}>
              <ResultAndCount
                label="Total Tasks"
                count={taskData.length}
                bgColor="rgba(0, 128, 0, 0.2)"
              />
              <ResultAndCount
                label="Created Today"
                count={0}
                bgColor="rgba(100, 100, 255, 0.2)"
              />
              <ResultAndCount
                label="Due today"
                count={0}
                bgColor="rgba(255, 0, 0, 0.2)"
              />
              <ResultAndCount
                label="Over Due"
                count={0}
                bgColor="rgba(180, 180, 100, 0.2)"
              />
            </div>
          </div>

          {/* Filters & Search */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search..."
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <CalendarInput
                  label="Date"
                  value={selectedDate}
                  onChange={setSelectedDate}
                  background="var(--Utility_Color1)"
                  textColor="gray"
                  iconColor="gray"
                  placeholderColor="gray"
                  borderRadius="25px"
                  shadow={false}
                />
                <Dropdown label="Staff" options={["02", "03", "04"]} />
                <Dropdown
                  label="Label"
                  options={["Toured", "Pending", "Closed"]}
                />
                <Dropdown label="Status" options={["Active", "Completed"]} />
              </div>
            </div>

            {/* Dynamic Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            {/* Pagination */}
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        
      </div>
      <CopyRight />
    </div>
  );
}

export default Tasks;
